import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Button,
  Dimmer,
  Grid,
  Label,
  Loader,
  Icon,
  Table,
  Menu,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import { push, replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import qs from 'qs';
import { decodeSearch, encodeSearch } from '../../utils/url';
import isNumber from '../../utils/numbers/isNumber';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import NavBar from '../../components/NavBar';
import PageNav from '../../components/PageNav';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import { SelectList } from '../../components/Filters';
import BU_STATUS_FILTER from '../../constants/businessUnitStatusFilter';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class BusinessUnitList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      companyBranch: PropTypes.shape({
        id: PropTypes.number,
      }),
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  constructor(props) {
    super(props);
    const query = decodeSearch(props.location.search);
    const search = query.search || '';
    const statusFilter = query.statusFilter || '';
    this.state = {
      data: [],
      count: 0,
      limit: 0,
      offset: 0,
      currentPage: parseInt(query.page, 10) || 1,
      search,
      advanceFilter: false,
      statusFilter,
      token: null,
      loading: true,
      isMobile: window.innerWidth < 768,
    };
    if ((query.statusFilter && query.statusFilter.length > 0)) {
      this.state.advanceFilter = true;
    }
  }
  componentWillMount() {
    window.addEventListener('resize', this.handleResize);
  }
  componentDidMount() {
    const { store } = this.context;
    const { query } = this.props.location;
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    if (!this.hasAccess()) {
      store.dispatch(replace('/forbidden/'));
      return;
    }
    window.addEventListener('resize', this.handleResize, false);
    store.dispatch(replace(`/business_units/?${qs.stringify(query)}`));
  }
  componentWillReceiveProps(nextProps) {
    const { query } = nextProps.location;
    this.fetchBusinessUnits(query);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setBusinessUnits(data = [], limit) {
    return new Promise((res) => {
      this.setState({
        data: data ? data.slice(0, limit) : [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getAccessStatus(value) {
    const { t } = this.props;
    const status = BU_STATUS_FILTER.find(s => s.value === value);
    if (status) {
      return t(status.text, { ns: TRANSLATION_FILES.constants });
    }
    return '';
  }
  hasAccess(check = false) {
    if (
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  async fetchBusinessUnits(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    if (!('statusFilter' in q)) {
      q.statusFilter = 'active';
    }
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      const data = await res.json();
      await this.setBusinessUnits(data, limit);

      // handle token.. etc
      await this.setComponentState({
        token,
        count,
        limit,
        offset,
      });
    }
    await this.setLoading(false);
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query);
  }
  handleClearFilter = (...queryArray) => {
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      delete query[filter];
      if (filter === "search"){
        this.setState({
          search: '',
        });
      }
      if (filter === "statusFilter"){
        this.setState({
          statusFilter: '',
        });
      }
    });
    this.replaceQuery(query);
  }
  handleOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    if (queryName === "search"){
      this.setState({
        search: value,
      });
    }
    if (queryName === "statusFilter"){
      this.setState({
        statusFilter: value,
      });
    }
    this.replaceQuery(query);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      state.isMobile = isMobile;
      this.setState({ ...state });
    }
  }
  replaceQuery(query) {
    const { store } = this.context;
    store.dispatch(push(`/business_units/?${encodeSearch(query)}`));
  }
  sortItems = [
    {
      text: 'Newest',
      icon: 'sort numeric descending',
      sortColumn: 'company_branch.created_at',
      sortDirection: 'desc',
    },
    {
      text: 'Oldest',
      icon: 'sort numeric ascending',
      sortColumn: 'company_branch.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Name Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'company_branch.name',
      sortDirection: 'asc',
    },
    {
      text: 'Name Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'company_branch.name',
      sortDirection: 'desc',
    },
  ];
  render() {
    const { store } = this.context;
    const { isMobile } = this.state;
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('List')}
          rightNav={
            <Menu.Item fitted>
              <Button
                primary
                icon="add"
                content={t('Business Unit')}
                disabled={this.state.loading}
                onClick={() => store.dispatch(push('/business_units/new/'))}
              />
            </Menu.Item>
          }
        />
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              {/* Search Filters */}
              <SearchFilter
                advanceFilter={this.state.advanceFilter}
                isLoading={this.state.loading}
                onChange={this.handleOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                setAdvanceFilter={this.handleSetAdvanceFilter}
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.data.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <SortButton
                    loading={this.state.loading}
                    items={this.sortItems}
                    onSort={this.handleSortData}
                  />
                )}
              >
              <SelectList
                filterName="statusFilter"
                headerText={null}
                onChange={this.handleOnChange}
                onClose={this.handleClearFilter}
                options={BU_STATUS_FILTER.map(s => ({
                  ...s,
                  text: t(s.text, { ns: TRANSLATION_FILES.constants }),
                }))}
                placeholder={t('Select Status')}
                value={this.state.statusFilter}
              />
             </SearchFilter>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Dimmer
                inverted
                active={this.state.loading && this.state.data.length > 0}
              >
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Table
                celled
                selectable
                compact
                className="app--tablelist"
              >
                <Table.Header className="mobile-hide">
                  <Table.Row>
                    <Table.HeaderCell>{t('Name')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Short Name')}</Table.HeaderCell>
                    <Table.HeaderCell textAlign={isMobile ? 'left' : 'center'}>{t('Agency')}</Table.HeaderCell>
                    <Table.HeaderCell textAlign={isMobile ? 'left' : 'center'}>{t('Reservation Limit')}</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    this.state.data.length > 0 ?
                      this.state.data.map((data, idx) => (
                        <Table.Row
                          key={idx}
                          title={t('View Business Unit')}
                          onClick={() => store.dispatch(push(`/business_units/${data.id}/`))}
                        >
                          <Table.Cell>
                            <Icon name="id card outline" className="computer-hide" />
                            <Link to={`/business_units/${data.id}/`}>
                              <b>{data.name}</b>&nbsp;
                              <Icon style={{ float: 'right' }} name="chevron right" className="computer-hide" />
                            </Link>
                            <Label size="mini" style={{ marginLeft: '0.5em' }}>{this.getAccessStatus(data.statusID)}</Label>
                            {
                              this.props.auth.companyBranch && this.props.auth.companyBranch.id === data.id ?
                                <Label size="mini" pointing="left">{t('Your branch')}</Label> : ''
                            }
                          </Table.Cell>
                          <Table.Cell>
                            <Icon name="user" className="computer-hide" />{data.shortName}
                          </Table.Cell>
                          <Table.Cell textAlign={isMobile ? 'left' : 'center'}>
                            <Icon name="home" className="computer-hide" />
                            <Label size="mini" color={data.isExternal ? 'teal' : 'grey'} content={t(data.isExternal ? 'Agency' : 'Non-Agency')} />
                          </Table.Cell>
                          <Table.Cell textAlign={isMobile ? 'left' : 'center'}>
                            <Icon name="building" className="computer-hide" /> {data.reservationLimit}
                          </Table.Cell>
                        </Table.Row>
                      ))
                      :
                      <Table.Row>
                        <Table.Cell colSpan="4" textAlign="center">
                          {
                            this.state.loading ?
                              <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                            : <p>{t('No business units found')}</p>
                          }
                        </Table.Cell>
                      </Table.Row>
                  }
                </Table.Body>
                <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan="4" textAlign="center">
                      <PageNav
                        upward
                        currentPage={this.state.currentPage}
                        count={this.state.count}
                        limit={this.state.limit}
                        offset={this.state.offset}
                        dataSize={this.state.data.length}
                        loading={this.state.loading}
                        onChange={this.handleChangePage}
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(BusinessUnitList.mapStateToProps)(BusinessUnitList));



// WEBPACK FOOTER //
// ./src/containers/BusinessUnits/List.jsx